import React, { FC } from "react";
import "../css/main-bcb.css";
import { Button } from "@core/uilibrary";

interface MainBreadcrumbProps {
  title: string;
  paragraph: string;

  // optional button config
  buttonEnabled?: boolean;
  buttonLabel?: string;
  onButtonClick?: () => void;
  sizeBtn?: string;
}

const MainBreadcrumb: FC<MainBreadcrumbProps> = ({
  title,
  paragraph,
  buttonEnabled = false,
  buttonLabel,
  onButtonClick,
  sizeBtn
}) => {
  return (
    <section className="scl--bdc-sect-const-cont">
      <div className="scl--bdc-cp-const-sty-box">
        <h3>{title}</h3>
        <p>{paragraph}</p>
      </div>

      {buttonEnabled && buttonLabel && (
        <div>
          <Button
            size={sizeBtn}
            value={buttonLabel}
            type="button"
            onClick={onButtonClick}
          />
        </div>
      )}
    </section>
  );
};

export default MainBreadcrumb;